/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slim_Free_Snake_FadeInputs */

const en_slim_free_snake_fade = /** @type {(inputs: Slim_Free_Snake_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_slim_free_snake_fade = /** @type {(inputs: Slim_Free_Snake_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Slim_Free_Snake_FadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slim_free_snake_fade = /** @type {((inputs?: Slim_Free_Snake_FadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slim_Free_Snake_FadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_slim_free_snake_fade(inputs)
	return de_slim_free_snake_fade(inputs)
});